// extracted by mini-css-extract-plugin
export default {"looseLeafModal":"s8Un8yapTMnOnLtQ151v"};